import React, { useEffect } from "react";

const TermAndConditions = () => {
   useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <div className="m-auto my-20 max-md:my-4 w-[80%] justify-center items-center p-8 border rounded-lg shadow-lg bg-white">
      <div className="p-6">
        <h1 className="text-3xl font-bold mb-4 text-[#730000]">Terms and Conditions</h1>

        <div className="bg-gray-100 p-6 mt-6 rounded-lg">
        <h2 className="text-2xl font-semibold mt-4 mb-2 text-[#730000]">
          1. General Terms of Use
        </h2>
        <p className="mb-2">
          1. Platform Use: By using SelectProposal.com, you acknowledge that you
          are accessing a global matrimonial matchmaking platform designed to
          facilitate connections between users. You agree to use the platform
          for lawful purposes and in compliance with all applicable laws.
        </p>
        <p className="mb-2">
          2. Age Requirement: Users must be at least 18 years old to register on
          SelectProposal.com. By creating an account, you confirm that you meet
          this age requirement.
        </p>
        </div>

        <div className="bg-gray-100 p-6 mt-6 rounded-lg">
          <h2 className="text-2xl font-semibold mt-4 mb-2 text-[#730000]">
            2. Registration and Account
          </h2>
          <p className="mb-2">
            3. Account Creation: Users must create an account to access and use
            the platform. During registration, you agree to provide accurate,
            complete, and up to date information. You are responsible for
            maintaining the confidentiality of your login credentials.
          </p>
          <p className="mb-2">
            Account Security: You agree to take all reasonable precautions to
            protect your account information. You must notify SelectProposal.com
            immediately of any unauthorized use of your account.
          </p>
        </div>

        <div className="bg-gray-100 p-6 mt-6 rounded-lg">
          <h2 className="text-2xl font-semibold mt-4 mb-2 text-[#730000]">
            3. User Content and Conduct
          </h2>
          <p className="mb-2">
            5. User Generated Content: By submitting content to SelectProposal.com
            (e.g., profiles, messages, photos), you grant SelectProposal.com a
            non exclusive, worldwide, royalty free license to use, distribute, and
            display this content.
          </p>
          <p className="mb-2">
            6. Prohibited Content: You agree not to upload or share content that
            is offensive, defamatory, harassing, illegal, or violates the rights
            of others. Content promoting illegal activities or discrimination
            based on race, religion, gender, or other protected characteristics is
            strictly prohibited.
          </p>
        </div>

        <div className="bg-gray-100 p-6 mt-6 rounded-lg">
          <h2 className="text-2xl font-semibold mt-4 mb-2 text-[#730000]">
            4. Privacy and Data Protection (GDPR Compliance)
          </h2>
          <p className="mb-2">
            7. GDPR Compliance: SelectProposal.com complies with the General Data
            Protection Regulation (GDPR). We are committed to ensuring your data
            is handled with the utmost care. Please refer to our Privacy Policy
            for details on how we collect, use, and protect your personal data.
          </p>
          <p className="mb-2">
            8. Data Collection: By registering, you consent to the collection,
            storage, and processing of your personal data, including sensitive
            information related to your matrimonial preferences, in accordance
            with the Privacy Policy.
          </p>
          <p className="mb-2">
            9. Data Subject Rights: Under GDPR, you have the right to access,
            correct, and request the deletion of your personal data. You may also
            withdraw consent for the processing of your data at any time. To
            exercise these rights, please contact us at email or contact
            information.
          </p>
        </div>

        <div className="bg-gray-100 p-6 mt-6 rounded-lg">
          <h2 className="text-2xl font-semibold mt-4 mb-2 text-[#730000]">
            5. Disclaimers and Limitation of Liability
          </h2>
          <p className="mb-2">
            10. Accuracy of Information: While SelectProposal.com strives to
            ensure the accuracy and completeness of the information on the
            platform, we do not guarantee that the profiles, proposals, or any
            other information provided is correct, complete, or up to date. Users
            are encouraged to conduct their own due diligence.
          </p>
          <p className="mb-2">
            11. Liability Disclaimer: SelectProposal.com is a platform
            facilitating user interactions. We do not verify the truthfulness or
            authenticity of user profiles or communications. We expressly disclaim
            all liability for any damages or losses arising out of the use of or
            reliance on information from other users.
          </p>
          <p className="mb-2">
            12. No Responsibility for User Interactions: SelectProposal.com is not
            responsible for any interactions between users, whether online or
            offline, including any disputes, agreements, or conflicts that arise.
            You acknowledge that any interactions are at your own risk.
          </p>
        </div>

        <div className="bg-gray-100 p-6 mt-6 rounded-lg">
          <h2 className="text-2xl font-semibold mt-4 mb-2 text-[#730000]">
            6. User Responsibilities and Due Diligence
          </h2>
          <p className="mb-2">
            13. Due Diligence: You agree to exercise caution and conduct thorough
            research when engaging with other users. SelectProposal.com does not
            verify the intentions, identity, or background of users and is not
            responsible for any actions or conduct of other users.
          </p>
          <p className="mb-2">
            14. Respectful Conduct: Users are expected to interact with one
            another in a respectful and professional manner. Harassment, offensive
            behavior, or illegal activities may result in account suspension or
            termination.
          </p>
        </div>

        <div className="bg-gray-100 p-6 mt-6 rounded-lg">
          <h2 className="text-2xl font-semibold mt-4 mb-2 text-[#730000]">
            7. Service Availability
          </h2>
          <p className="mb-2">
            15. Platform Availability: SelectProposal.com aims to provide
            uninterrupted access to the platform. However, we do not guarantee
            that the platform will be available at all times or error-free. We
            reserve the right to modify or suspend any part of the platform
            without notice.
          </p>
          <p className="mb-2">
            16. Updates and Changes: We may update the platform periodically,
            including changes to the user interface, features, or functionality.
            SelectProposal.com does not guarantee that the platform will always
            function in the same way as previous versions.
          </p>
        </div>

        <div className="bg-gray-100 p-6 mt-6 rounded-lg">
          <h2 className="text-2xl font-semibold mt-4 mb-2 text-[#730000]">
            8. Termination and Suspension of Accounts
          </h2>
          <p className="mb-2">
            17. Account Suspension/Termination: We reserve the right to suspend or
            terminate your account if you violate these Terms and Conditions or
            engage in any unlawful or unethical conduct. You may also close your
            account at any time by contacting us.
          </p>
          <p className="mb-2">
            18. Effect of Termination: Upon termination, your right to use the
            platform will be revoked, and any content you have posted may be
            removed from the site, in accordance with our Privacy Policy.
          </p>
        </div>

        <div className="bg-gray-100 p-6 mt-6 rounded-lg">
          <h2 className="text-2xl font-semibold mt-4 mb-2 text-[#730000]">
            9. Modifications to Terms and Conditions
          </h2>
          <p className="mb-2">
            19. Changes to Terms: SelectProposal.com reserves the right to modify
            or update these Terms and Conditions at any time. Changes will be
            effective immediately upon posting on the website. We encourage you to
            review these Terms periodically.
          </p>
          <p className="mb-2">
            20. Notification of Changes: We may notify you of changes to the Terms
            through email or by posting updates on the website. Continued use of
            the platform after such modifications will signify your acceptance of
            the revised Terms.
          </p>
        </div>

        <div className="bg-gray-100 p-6 mt-6 rounded-lg">
          <h2 className="text-2xl font-semibold mt-4 mb-2 text-[#730000]">
            10. Governing Law and Dispute Resolution
          </h2>
          <p className="mb-2">
            21. Governing Law: These Terms and Conditions will be governed by and
            construed in accordance with the laws of Pakistan. Any disputes
            arising out of your use of SelectProposal.com will be subject to the
            exclusive Pakistan of the courts in Pakistan.
          </p>
          <p className="mb-2">
            22. Dispute Resolution: Any disputes should be first addressed through
            direct communication with SelectProposal.com. If resolution cannot be
            reached, users may seek mediation or legal recourse in accordance with
            local laws.
          </p>
        </div>

        <div className="bg-gray-100 p-6 mt-6 rounded-lg">
          <h2 className="text-2xl font-semibold mt-4 mb-2 text-[#730000]">
            11. Contact Information
          </h2>
          <p className="mb-2">
            23. Contact Us: For any questions, concerns, or to exercise your data
            rights under GDPR, please contact SelectProposal.com at email or contact
            information.
          </p>
        </div>

        <p className="font-semibold mt-4">Additional Notes:</p>
        <ul className="list-disc pl-6 bg-gray-100 p-6 rounded-lg">
          <li>
            Global Use Disclaimer: SelectProposal.com operates globally. Users
            are responsible for ensuring compliance with local laws when using
            the platform, especially regarding data protection and privacy.
          </li>
          <li>
            User Conduct: By using the platform, you agree to behave
            respectfully and responsibly toward others. Any harmful or unlawful
            behavior may result in immediate action, including account
            suspension or legal action.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default TermAndConditions;
